import { IconButton, InputAdornment, Tooltip } from '@mui/material';

import { IconVisibilityMS, IconVisibilityOffMS } from '../../constants/icons';

interface PasswordToggleProps {
  visible: boolean;
  onToggle: () => void;
  showLabel: string;
  hideLabel: string;
}

/** End adornment that flips a password field between masked and plain text. */
export function PasswordToggle({
  visible,
  onToggle,
  showLabel,
  hideLabel,
}: PasswordToggleProps): JSX.Element {
  const label = visible ? hideLabel : showLabel;
  return (
    <InputAdornment position="end">
      <Tooltip title={label}>
        <IconButton
          size="small"
          aria-label={label}
          onClick={onToggle}
          edge="end"
        >
          {visible ? IconVisibilityOffMS : IconVisibilityMS}
        </IconButton>
      </Tooltip>
    </InputAdornment>
  );
}
